export const getPositiveNumber = (number) => {
    return number ? number.toString().includes('-') : false
}
